module.exports = __webpack_public_path__ + "static/img/kayi-logo.72fee18.png";


//////////////////
// WEBPACK FOOTER
// ./packages/assets/kayi-logo.png
// module id = njxU
// module chunks = 1